// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import firebaseApp from './firebaseApp'
import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'

Vue.use(VueMaterial)
Vue.use(VCalendar)
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth) {
    firebaseApp.auth().onAuthStateChanged(function (user) {
      if (user) {
        next()
      } else {
        if (to.name === 'Entry') {
          // TODO: ここでUserを検索して該当のuserIdがなければHomeに飛ばすあればEntryLoginへ飛ばす
          next({name: 'EntryLogin', params: to.params})
        } else {
          next({name: 'Home'})
        }
      }
    })
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js